<p-fileUpload
  #fileUpload
  [customUpload]="true"
  [accept]="acceptedFileExtentions()"
  [maxFileSize]="maxFileSize() * 1000000"
  [invalidFileSizeMessageSummary]="'invalid_file_size_summary' | translate"
  [invalidFileSizeMessageDetail]="'max_upload_size_detail' | translate: { max: maxFileSize() }"
  [invalidFileTypeMessageSummary]="invalidFileTypeMessageSummary()"
  [invalidFileTypeMessageDetail]="invalidFileTypeMessageDetailResolved()"
  [multiple]="multiple()"
  [disabled]="disabled()"
  (onSelect)="onSelectedFileEvent.emit($event)">
  <ng-template pTemplate="header"></ng-template>

  <ng-template pTemplate="content" let-chooseCallback="chooseCallback" let-clearCallback="clearCallback">
    @if (!hasFile()) {
      <button
        type="button"
        class="kl-upload-adv__dropzone"
        [disabled]="disabled()"
        (click)="choose($event, chooseCallback)">
        <i class="ph ph-cloud-arrow-up kl-upload-adv__cloud" aria-hidden="true"></i>
        <span class="kl-upload-adv__title">{{ 'upload_drag_drop_files' | translate }}</span>
        <span class="kl-upload-adv__helper">{{ helperText() }}</span>
      </button>
    } @else {
      <div class="kl-upload-adv__card">
        <i
          class="ph kl-upload-adv__type-icon"
          [class]="'ph kl-upload-adv__type-icon ' + fileTypeIconClass()"
          aria-hidden="true"></i>
        <div class="kl-upload-adv__meta">
          <span class="kl-upload-adv__name" [title]="fileName()">{{ fileName() }}</span>
          @if (sizeLabel()) {
            <span class="kl-upload-adv__size">{{ sizeLabel() }}</span>
          }
        </div>
        <div class="kl-upload-adv__actions">
          <button
            type="button"
            class="kl-upload-adv__btn ph ph-paperclip"
            [pTooltip]="'select' | translate"
            tooltipPosition="top"
            [attr.aria-label]="'select' | translate"
            [disabled]="disabled()"
            (click)="choose($event, chooseCallback)"></button>
          @if (canPreview()) {
            <button
              type="button"
              class="kl-upload-adv__btn kl-upload-adv__btn--show ph ph-eye"
              [pTooltip]="'upload_show_file' | translate"
              tooltipPosition="top"
              [attr.aria-label]="'upload_show_file' | translate"
              (click)="showFileEvent.emit()"></button>
          }
          <button
            type="button"
            class="kl-upload-adv__btn kl-upload-adv__btn--clear ph ph-x"
            [pTooltip]="'delete' | translate"
            tooltipPosition="top"
            [attr.aria-label]="'delete' | translate"
            [disabled]="disabled()"
            (click)="clear(clearCallback)"></button>
        </div>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="file"></ng-template>
  <ng-template pTemplate="empty"></ng-template>
</p-fileUpload>
